var map = {
	"./architecturebanner.png": 8651,
	"./button_sort.png": 6074,
	"./card_ac.png": 3900,
	"./card_ad.png": 8051,
	"./card_ah.png": 1633,
	"./card_as.png": 2938,
	"./card_backside.png": 2436,
	"./card_jc.png": 1880,
	"./card_jd.png": 8704,
	"./card_jh.png": 5566,
	"./card_js.png": 6971,
	"./card_kc.png": 4560,
	"./card_kd.png": 1333,
	"./card_kh.png": 6565,
	"./card_ks.png": 6544,
	"./card_nc.png": 1704,
	"./card_nd.png": 1946,
	"./card_nh.png": 6689,
	"./card_ns.png": 4945,
	"./card_qc.png": 2169,
	"./card_qd.png": 8769,
	"./card_qh.png": 6277,
	"./card_qs.png": 208,
	"./card_tc.png": 2996,
	"./card_td.png": 7944,
	"./card_th.png": 4920,
	"./card_ts.png": 9893,
	"./current_player_indicator.png": 962,
	"./logo_nokadasoft_light_33.png": 8767,
	"./swagger.png": 5253
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;